<template>
  <v-card class="elevation-12">
    <v-toolbar
        color="primary"
        dark
        flat
    >
      <v-toolbar-title>Вход в систему</v-toolbar-title>
      <v-spacer></v-spacer>
    </v-toolbar>
    <v-card-text>
      <v-form>
        <v-text-field
            label="Логин"
            v-model="username"
            prepend-icon="mdi-account"
            type="text"
            :error-messages="usernameErrorMessages"
            @keyup.enter="onFormSubmit"
        ></v-text-field>

        <v-text-field
            v-model="password"
            label="Пароль"
            prepend-icon="mdi-lock"
            type="password"
            :error-messages="passwordErrorMessages"
            @keyup.enter="onFormSubmit"
        ></v-text-field>

        <v-snackbar v-model="isLoginFailed"
                    :timeout="5000"
                    :top="true"
                    color="error"
        >
          Не удалось войти в систему. Проверьте логин и пароль
        </v-snackbar>
      </v-form>
    </v-card-text>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn color="primary" @click="onLoginButtonClicked">Войти</v-btn>
    </v-card-actions>

    <v-overlay :value="isLoading">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
  </v-card>
</template>

<script>
import {required} from 'vuelidate/lib/validators'
import {AUTH_REQUEST} from "@/store/modules/auth/actions";
import {AUTH_FAILED} from "@/events/auth";

export default {
  name: "Login",
  data() {
    return {
      username: '',
      password: '',

      isLoginFailed: false,
      isLoading: false
    };
  },
  validations: {
    username: {
      required
    },
    password: {
      required
    }
  },
  computed: {
    usernameErrorMessages() {
      const errors = [];
      if (this.$v.username.$dirty) {
        !this.$v.username.required && errors.push('Введите Ваш логин');
      }
      return errors;
    },
    passwordErrorMessages() {
      const errors = [];
      if (this.$v.password.$dirty) {
        !this.$v.password.required && errors.push('Введите Ваш пароль');
      }
      return errors;
    }
  },
  methods: {
    onLoginButtonClicked() {
      this.auth();
    },
    onFormSubmit() {
      this.auth();
    },

    auth() {
      this.$v.$touch();

      if (!this.$v.$invalid) {
        this.isLoginFailed = false;

        this.isLoading = true;
        this.$store.dispatch(AUTH_REQUEST, {username: this.username, password: this.password})
      }
    },
    onAuthFailed() {
      this.isLoading = false;
      this.isLoginFailed = true;
    }
  },
  created() {
    this.$bus.$on(AUTH_FAILED, this.onAuthFailed)
  },
  beforeDestroy() {
    this.$bus.$off(AUTH_FAILED, this.onAuthFailed)
  }
}
</script>